module.exports = __webpack_public_path__ + "img/image 24.8fe60602.png";